<template>
    <div
        data-testid="page:main:business"
        class="business no-overflow"
    >
        <MainSectionSlider :slides-data="businessModel.slidesData" />
        <div class="business-benefits">
            <div class="wrapper">
                <h2 class="h2">Выгодные предложения для бизнеса</h2>
                <UITabs
                    :tabs="businessModel.tabsData"
                    variant="filled"
                    theme="monochrome"
                >
                    <template
                        v-for="{slotName} in businessModel.tabsData"
                        #[slotName]
                    >
                        <OfferSlider
                            :key="slotName"
                            :slides-data="businessModel[slotName]"
                        />
                    </template>
                </UITabs>
            </div>
        </div>
        <div class="business-services">
            <div class="wrapper">
                <Services :useful-cards="businessModel.servicesData" />
            </div>
        </div>
        <AdditionalWidgets />
        <PressReleases />
    </div>
</template>

<script>
import {defineComponent} from 'vue';

import * as BusinessModel from '@/core/models/pages/business-page/BusinessModel';

import MainSectionSlider from '@/components/Sliders/MainSectionSlider/MainSectionSlider.vue';
import OfferSlider from '@/components/Sliders/OfferSlider/OfferSlider.vue';
import PressReleases from '@/components/Pages/HomePage/PressReleases/index.vue';
import Services from '@/components/Pages/HomePage/Services.vue';
import AdditionalWidgets from '@/components/Pages/HomePage/AdditionalWidgets.vue';
import UITabs from '@/components/UI-components/Tabs/UITabs.vue';

export default defineComponent({
    name: 'BusinessPage',
    components: {
        MainSectionSlider,
        OfferSlider,
        PressReleases,
        Services,
        AdditionalWidgets,
        UITabs,
    },
    setup() {
        return {
            businessModel: BusinessModel,
        };
    },
});
</script>

<style lang="scss">
@import '@/assets/styles/pages/business/business';
</style>
